import { connect } from 'react-redux'
import { fetchGifsFromUrl } from 'shared/redux/fetch-gifs'
import { fetchChannel } from 'shared/redux/fetch-channel'
import { toggleAutoPlay, checkForNewGifs, showNewGifs, trackShare } from '../shared/actions'
import { toggleEditMode, updateEditMode } from 'shared/redux/edit-mode'
import * as selectors from 'shared/redux/reducers'
import Channel from '../components/channel'
import { getSocialUrls, socialClick } from 'shared/util/gif-social'
import { getEmbedCode } from 'shared/util/gif-embed'
import { processChannelGifs } from 'shared/util/gif-process'
import { receivedGifs } from 'shared/redux/gifs'

const enhance = connect(
    (state, { channelId, gridType, channelType }) => {
        const channel = selectors.getChannel(state, channelId)
        return {
            channel,
            getSocialUrls,
            autoPlay: selectors.getAutoPlay(state),
            gridType: gridType === 'list' ? 'list' : selectors.getGridType(state),
            // isFetching applies only to the state.gifs and will show a loader
            isFetching: selectors.getFetching(state, `CHANNEL - ${channelId}`),
            gifs: gridType === 'list' ? selectors.getGifs(state) : selectors.getGifs(state, `CHANNEL - ${channelId}`),
            showGridNavInHeader: selectors.getGridNavInHeader(state, channelType),
            isPolling: selectors.getPolling(state),
            lastPolled: selectors.getLastPolled(state),
            newGifs: selectors.getNewGifs(state),
            addedGifIds: selectors.getAddedGifIds(state),
            getEmbed: getEmbedCode,
            socialClick: socialClick.desktop,
            editMode: selectors.getEditMode(state),
            nextUrl: selectors.getNextUrl(state),
        }
    },
    (dispatch, ownProps) => ({
        fetchChannel: channelId => dispatch(fetchChannel(channelId)),
        fetchGifs: ownProps.fetchGifs
            ? ownProps.fetchGifs
            : (nextUrl, processor) =>
                  dispatch(
                      fetchGifsFromUrl(nextUrl, {
                          groupId: `CHANNEL - ${ownProps.channelId}`,
                          processor,
                      }),
                  ),
        toggleAutoPlay: () => dispatch(toggleAutoPlay()),
        checkForNewGifs: () => dispatch(checkForNewGifs(ownProps.channelId)),
        showNewGifs: () => dispatch(showNewGifs(ownProps.groupId)),
        onSocialClick: (id, type) => dispatch(trackShare(id, type)),
        toggleEditMode: () => dispatch(toggleEditMode()),
        updateEditMode: () => dispatch(updateEditMode()),
        receivedGifs: options => dispatch(receivedGifs(options)),
    }),
    (stateProps, dispatchProps, ownProps) => ({
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        fetchGifs: (chosenUrl, chosenProcessor) => {
            const processor = chosenProcessor || processChannelGifs
            const url = chosenUrl || stateProps.nextUrl
            return dispatchProps.fetchGifs(url, processor)
        },
    }),
)

export default enhance(Channel)
